<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content" mat-dialog-content>
  <div class="tabs">
    <div
      class="tab"
      [ngClass]="{ active: index === 1 }"
      (click)="changeTime(1)"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 1"
        alt=""
      />
      <span style="margin-bottom: 10px">冻结3个月</span>
      <span>赠送3个月爆米花全家桶会员</span>
    </div>
    <div
      class="tab"
      [ngClass]="{ active: index === 2 }"
      (click)="changeTime(2)"
    >
      <img
        src="../../../../assets/images/compensate/check.png"
        *ngIf="index === 2"
        alt=""
      />
      <span style="margin-bottom: 10px">冻结6个月</span>
      <span>赠送6个月爆米花全家桶会员</span>
    </div>
  </div>
  <div class="detail">
    <div class="imgs">
      <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
      <img src="../../../../assets/images/compensate/change.webp" alt="" />
      <span class="huiyuan">
        <img
          src="../../../../assets/images/compensate/dongjie.png"
          alt=""
          class="huiyuan"
        />暂时冻结
      </span>
    </div>
    <div class="item">
      <span class="left">解冻后有效期：</span>
      <span class="right">
        <app-datetime [text]="now"></app-datetime>
        <br />
        <app-datetime [text]="after"></app-datetime>
      </span>
    </div>
  </div>
</div>
<div class="button">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="refund()"
  >
    确认冻结
  </button>
</div>
